export const pageTitle = (title) => {
  return (document.title = title + ' - Tien Duc Dental');
};
